const _excluded = ["text", "paymentMethodType", "parenthesisText", "icon", "selected", "className", "disabled", "mobileView", "children", "onOptionClick", "data-testid"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { forwardRef } from 'react';
import cn from 'classnames';
import { RadioButton, Typography, Collapse } from 'seagull';
import styles from "./PaymentMethodOption.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const paymentMethodTypeTextMap = {
  bankAccount: 'Bank account',
  creditCard: 'Credit card'
};
const PaymentMethodOption = /*#__PURE__*/forwardRef(function PaymentMethodOption(props, ref) {
  const {
      text = '',
      paymentMethodType,
      parenthesisText,
      icon,
      selected,
      className,
      disabled,
      mobileView,
      children,
      onOptionClick,
      'data-testid': testid
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: ref,
    "aria-selected": selected,
    className: cn(styles.optionWrapper, {
      [styles.selected]: selected,
      [styles.mobileView]: mobileView,
      [styles.disabled]: disabled
    }, className),
    "data-testid": testid
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      className: styles.option,
      disabled: disabled,
      onClick: onOptionClick,
      "data-testid": testid && testid + '-button',
      children: [mobileView && /*#__PURE__*/_jsx(RadioButton, {
        checked: selected
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.name,
        children: [/*#__PURE__*/_jsx(Typography, {
          as: "span",
          skin: disabled ? 'secondary' : 'standard',
          children: paymentMethodType ? paymentMethodTypeTextMap[paymentMethodType] : text
        }), "\xA0", parenthesisText && /*#__PURE__*/_jsxs(Typography, {
          "data-testid": "payment-method-option-parenthesis",
          as: "span",
          variant: "paragraph2",
          skin: "secondary",
          children: ["(", parenthesisText, ")"]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: disabled ? styles.iconDisabled : styles.icon,
        children: icon
      })]
    }), mobileView && children && /*#__PURE__*/_jsx(Collapse, {
      in: selected,
      unmountOnExit: true,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.collapsedArea,
        children: children
      })
    })]
  }));
});
export default PaymentMethodOption;